import type { RefAttributes } from "react";
import type { PopoverProps as AriaPopoverProps } from "react-aria-components";
import { Popover as AriaPopover } from "react-aria-components";
import { cx } from "@/utils/cx";

interface PopoverProps extends AriaPopoverProps, RefAttributes<HTMLElement> {
  size: "sm" | "md";
  // Whether the listbox inside was given a fixed `items` list. A bounded list gets
  // capped (with a scrollbar) at a height that fits ~7 rows; without a fixed list
  // (e.g. free-text/search-driven results) the popover grows to fit its content.
  hasItems?: boolean;
}

export const Popover = ({ hasItems, ...props }: PopoverProps) => {
  return (
    <AriaPopover
      placement="bottom"
      containerPadding={0}
      offset={4}
      {...props}
      className={(state) =>
        cx(
          // pointer-events-auto: the popover portals to <body>, which a Radix
          // dialog sets to pointer-events:none — re-enable so clicks land.
          "pointer-events-auto w-(--trigger-width) overflow-x-hidden overflow-y-auto rounded-lg bg-primary py-1 shadow-none ring-1 ring-secondary_alt outline-hidden will-change-transform",

          hasItems && "max-h-[340px]!",

          state.isEntering &&
            "duration-150 ease-out animate-in fade-in placement-right:origin-left placement-right:slide-in-from-left-0.5 placement-top:origin-bottom placement-top:slide-in-from-bottom-0.5 placement-bottom:origin-top placement-bottom:slide-in-from-top-0.5",
          state.isExiting &&
            "duration-100 ease-in animate-out fade-out placement-right:origin-left placement-right:slide-out-to-left-0.5 placement-top:origin-bottom placement-top:slide-out-to-bottom-0.5 placement-bottom:origin-top placement-bottom:slide-out-to-top-0.5",

          typeof props.className === "function" ? props.className(state) : props.className,
        )
      }
    />
  );
};
